import { render } from "./InputTeks.vue?vue&type=template&id=5741a022&ts=true"
import script from "./InputTeks.vue?vue&type=script&lang=ts"
export * from "./InputTeks.vue?vue&type=script&lang=ts"

import exportComponent from "/home/dajetmiko/react/admin.animemo.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__